import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var PercentIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.899 5.53416C11.6768 5.53416 9.87539 7.33524 9.87539 9.55698C9.87539 11.7787 11.6768 13.5798 13.899 13.5798C16.1211 13.5798 17.9225 11.7787 17.9225 9.55698C17.9225 7.33524 16.1211 5.53416 13.899 5.53416ZM7.77979 9.55698C7.77979 6.17808 10.5194 3.43895 13.899 3.43895C17.2785 3.43895 20.0181 6.17808 20.0181 9.55698C20.0181 12.9359 17.2785 15.675 13.899 15.675C10.5194 15.675 7.77979 12.9359 7.77979 9.55698Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1006 34.4202C31.8785 34.4202 30.077 36.2213 30.077 38.443C30.077 40.6648 31.8785 42.4658 34.1006 42.4658C36.3228 42.4658 38.1242 40.6648 38.1242 38.443C38.1242 36.2213 36.3228 34.4202 34.1006 34.4202ZM27.9814 38.443C27.9814 35.0641 30.7211 32.325 34.1006 32.325C37.4801 32.325 40.2198 35.0641 40.2198 38.443C40.2198 41.8219 37.4801 44.5611 34.1006 44.5611C30.7211 44.5611 27.9814 41.8219 27.9814 38.443Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8741 2.10958C35.3923 2.36695 35.6038 2.99566 35.3464 3.51384L14.53 45.4182C14.2726 45.9363 13.6438 46.1478 13.1255 45.8904C12.6072 45.633 12.3958 45.0043 12.6532 44.4862L33.4695 2.58184C33.7269 2.06365 34.3558 1.85222 34.8741 2.10958Z"
  }));
});
PercentIcon.displayName = 'PercentIcon';
PercentIcon.defaultProps = {
  'aria-label': 'Percent'
};
export default PercentIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/PercentIcon/index.js
// module id = 1912
// module chunks = 12